<!--
Sticker
贴纸
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="贴纸" name="贴纸">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in sticker"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="stickerFormActive">
                <PvctapeSticker v-if="sticker[0].status"/>
                <BumperStickers v-if="sticker[1].status"/>
                <PvcStickers v-if="sticker[2].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import PvctapeSticker from "./Sticker/PvctapeSticker.vue";
import BumperStickers from "./Sticker/BumperStickers.vue";
import PvcStickers from "./Sticker/PvcStickers.vue";

export default {
  name: "Poster",
  methods: {},
  components: {
    PvctapeSticker,
    BumperStickers,
    PvcStickers,
  },
  data() {
    return {
      forcollapse: ['PVC透明胶贴纸','不干胶贴纸','PVC贴纸'],
      sticker: [
        { id: "PvctapeSticker", name: "PVC透明胶贴纸", status: false },
        { id: "BumperStickers", name: "不干胶贴纸", status: false },
        { id: "PvcStickers", name: "PVC贴纸", status: false }
      ],
      stickerFormActive: []
    };
  }
};
</script>
<style scoped>
</style>